'use client';

import { getMembershipPrice } from '@/features/membership/internal/helper/get-membership-price';
import { useCurrencyStore } from '@/features/shared/currency-store';
import { currencySelectors } from '@/features/currency-selector/state/currency-selectors';
import { useLocale } from 'next-intl';
import { LocaleCode } from '@/i18n/locales';

export const MembershipPrice = () => {
  const currentCurrency = useCurrencyStore(currencySelectors.currency);
  const currentLocale = useLocale() as LocaleCode;
  const price = getMembershipPrice(currentCurrency, currentLocale);

  return <>{price}</>;
};
